<template>
  <div class="login-phone-password-container">
    <div class="content">
      <div class="head">
        <div class="close" @click="$router.back()"></div>
        <div class="title">账号密码登录</div>
      </div>
      <div class="form">
        <Field
          class="input"
          v-model="password"
          type="password"
          placeholder="请输入密码"
          maxlength="11"
          autofocus
        />
        <Button class="btn" @click="loginHandle" :loading="loading"
          >立即登录</Button
        >
      </div>
      <div class="other">
        <!-- <span @click="toForgetPassword">忘记密码</span> -->
        <span @click="toCodeLogin">验证码登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Toast, Button, Dialog } from 'vant'
import { getBindWechatInfo } from '@/api/login'
import { isWechat } from '@/utils/auth'
export default {
  components: { Field, Button },
  data() {
    return {
      loading: false,
      phone: this.$route.query.phone,
      password: '',
      redirect: undefined,
      otherQuery: {},
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true,
    },
  },
  methods: {
    loginHandle() {
      if (/^[a-zA-Z0-9_-]{6,16}$/.test(this.password)) {
        const params = new FormData()
        params.append('username', this.phone)
        params.append('password', this.password)
        params.append('scope', 'h5')
        params.append('grant_type', 'password')
        this.loading = true
        this.$store
          .dispatch('user/loginPhonePassword', params)
          .then(async (res) => {
            this.loading = false
            // Toast.success("登录成功");

            console.log('this.redirect', this.redirect)
            if (this.redirect && this.redirect !== '/') {
              this.$router.push({
                path: this.redirect,
                query: this.otherQuery,
              })
            } else {
              return getBindWechatInfo()
            }
          })
          .then((res) => {

            if (!res) return false
            if (!isWechat() || res.data) {
              this.$router.push('/')
            } else {
              Dialog.confirm({
                message: `您的手机号还未绑定微信<br/>绑定微信有助您账户安全 请绑定微信`,
                theme: 'round-button',
                confirmButtonText: '去绑定',
                cancelButtonText: '取消',
                showCancelButton: true,
                closeOnClickOverlay: true,
                beforeClose: (action, done) => {
                  if (action === 'confirm') {
                    done()
                    this.$router.push({
                      path: '/mine/setting',
                    })
                  } else {
                    done()
                    this.$router.push('/')
                  }
                },
              }).catch(() => {})
            }
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        Toast.fail('请输入正确的密码')
      }
    },
    toForgetPassword() {
      this.$router.push({
        name: 'LoginForget',
        query: { ...this.$route.query, phone: this.phone },
      })
    },
    toCodeLogin() {
      // 手动发送验证码
      this.$router.replace({
        name: 'LoginPhoneCode',
        query: {
          ...this.$route.query,
          type: 'code_login',
          phone: this.phone,
        },
      })
      // 自动发送验证码
      // if (this.code_phone === this.phone && this.code_flag) {
      //   this.$router.push({
      //     name: 'LoginPhoneCode',
      //     query: { type: 'code_login', phone: this.phone },
      //   })
      // } else {
      //   this.loading = true
      //   this.$store
      //     .dispatch('sms/loginSendCode', this.phone)
      //     .then((res) => {
      //       this.loading = false
      //       res && Toast.success('已发送验证码')
      //       this.$router.push({
      //         name: 'LoginPhoneCode',
      //         query: { type: 'code_login', phone: this.phone, ...this.$route.query, },
      //       })
      //     })
      //     .catch(() => {
      //       this.loading = false
      //     })
      // }
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
  },
}
</script>

<style lang="less" scoped>
.close {
  display: inline-block;
  width: 30px;
  height: 4px;
  background: #333;
  border-radius: 4px;
  transform: rotate(45deg);
  &::after {
    content: '';
    display: block;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 4px;
    transform: rotate(-90deg);
  }
}
.login-phone-password-container {
  height: 100vh;
  width: 100vw;
  .content {
    width: 100%;
    padding: 0 40px;
  }
  .head {
    display: flex;
    align-items: center;
    padding: 30px 0;
    .title {
      flex: 1;
      font-size: 28px;
      line-height: 1;
      text-indent: -20px;
    }
  }
  .form {
    padding-top: 136px;
    .input {
      flex: 1;
      padding: 20 0;
      font-size: 36px;
      &::placeholder {
        color: #aeaeae;
      }
    }
    .btn {
      margin-top: 80px;
      width: 100%;
      background: #e82035;
      line-height: 82px;
      border-radius: 50px;
      font-size: 26px;
      text-align: center;
      color: #fff;
    }
  }
  .other {
    text-align: center;
    font-size: 26px;
    line-height: 36px;
    padding-top: 40px;
    span {
      color: #aeaeae;
      & + span {
        margin-left: 80px;
      }
    }
  }
}
</style>
